import React from 'react';
import ReactSummernote from 'react-summernote';
import 'react-summernote/dist/react-summernote.css';
import 'react-summernote/lang/summernote-ko-KR';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import Linker from '../../linker/Linker'
import * as path from '../../../../route/PathConfig'
import './NoticeCreateMain.css';

const InputText = React.memo(props=>{
  return(
    <input
      name={props.name}
      type={props.type}
      className={props.className}
      id={props.id}
      size={props.size}
      onChange={props.onChange}
      value={props.value}
      placeholder={props.placeholder}
    />
  )})

const NoticeCreateMain = (props) => {
  const onChange = (content) => {
    props.handleNoticeContent(content);
  }

  const onImageUpload = (images, insertImage) => {
    for ( let i = 0; i < images.length; i++ ) {
      const reader = new FileReader();

      reader.onloadend = () => {
        insertImage(reader.result);
      }
      reader.readAsDataURL(images[i]);
    }
  }

  return(
    <div className="row featured-main">
      <div className="NoticeTitle">
        <span className="purple">공지사항 작성</span>
      </div>
      <table className="NoticeCreateTable" width="100%">
        <tr>
          <td width="130px" valign="top" align="right" style={{paddingTop:"7px"}}>
            <span className="NoticeCreateTit">Title</span>
          </td>
          <td>
            <InputText onChange={props.handleTitleInput} value={props.noticeTitle} name="textfield" type="text" className="box" id="textfield" size="100" />
          </td>
        </tr>
        <tr>
          <td width="130px" valign="top" align="right" style={{paddingTop:"7px"}}>
            <span className="NoticeCreateTit">Content</span>
          </td>
          <td>
            <div className="NoticeCreateBtn">
              <a onClick={()=>props.handleSaveBtn()} className="button darkGray" style={{margin: "0px 5px 0px 0px"}}>저장</a>
              <Linker path={path.NOTICE}>
                <a className="button darkGray" style={{margin: "0px 5px 0px 0px"}}>취소</a>
              </Linker>
            </div>
            <ReactSummernote
              options={{
                lang: "ko-KR",
                height: 500,
                dialogsInBody: true,
                toolbar: [
                  ["style", ["style"]],
                  ["font", ["bold", "underline", "clear"]],
                  ["fontsizr", ["fontsize"]],
                  ["color", ["color"]],
                  ["fontname", ["fontname"]],
                  ["para", ["ul", "ol", "paragraph"]],
                  ["height", ["height"]],
                  ["table", ["table"]],
                  ["insert", ["link", "picture"]],
                  ["view", ["codeview"]]
                ]
              }}
              onChange={onChange}
              onImageUpload={onImageUpload}
            />
          </td>
        </tr>
      </table>
    </div>
  )
}

export default NoticeCreateMain;